import { render } from "./business.vue?vue&type=template&id=19bb9316&scoped=true"
import script from "./business.vue?vue&type=script&lang=js"
export * from "./business.vue?vue&type=script&lang=js"

import "./business.vue?vue&type=style&index=0&id=19bb9316&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-19bb9316"

export default script